import request, { post, get } from "@/utils/request";
import { ouchnCustom } from "../../service";

const urlGetUserOrderList = ouchnCustom + "/web/api/ocOrder/orderList";
const urlCreateOrder = ouchnCustom + "/web/api/ocOrder/addOcOrder";
const urlCreateSubjectOrder =
  ouchnCustom + "/web/api/ocOrder/addOcOrderSubject";
const urlGetOrderDetail = ouchnCustom + "/web/api/ocOrder/orderChildList";
const urlDeleteOrderRecordById = ouchnCustom + "/web/api/ocOrder/deleteById";
const urlGetTotalGroup = ouchnCustom + "/web/api/ocOrder/orderCountByStatus";
const urlCancelOrder = ouchnCustom + "/web/api/ocOrder/updateOrderStatus";
const urlAfterPay = ouchnCustom + "/web/api/ocOrder/addOrderInMyResource";
const urlCheckIsCreated = ouchnCustom + "/web/api/ocOrder/orderCompareByUserId";
const IntegralRecord = ouchnCustom + "/web/IntegralRecord/list";
const IntegralRecordCount = ouchnCustom + "/web/IntegralRecord/count";

// 获取用户订单列表
export const apiGetUserOrderList = (params) => get(urlGetUserOrderList, params);

// 创建订单
export const apiCreateOrder = (data) => post(urlCreateOrder, data);

// 创建专题订单
export const apiCreateSubjectOrder = (data) =>
  post(urlCreateSubjectOrder, data);

// 取消订单
// export const apiCancelOrder = (data) => post(urlCancelOrder, data)
export const apiCancelOrder = (data) => post(`${urlCancelOrder}?id=${data.id}`);

// 订单支付成功后修改订单状态
export const apiAfterPay = (data) => post(`${urlAfterPay}?id=${data.id}`);

// 获取订单明细列表
export const apiGetOrderDetail = (params) => get(urlGetOrderDetail, params);

// 获取用户订单各状态下的total数
export const apiGetTotalGroup = (params) => get(urlGetTotalGroup, params);

// 验证该商品是否已提交过订单
export const apiCheckIsCreated = (params) => get(urlCheckIsCreated, params);

// 根据主键删除订单记录
export const apiDeleteOrderRecordById = (params) => {
  return request({
    url: urlDeleteOrderRecordById,
    method: "delete",
    params,
  });
};
// 积分
export const Integral = (params) => {
  return request({
    url: IntegralRecord,
    method: "get",
    params,
  });
};
// 总计
export const IntegralCount = (params) => {
  return request({
    url: IntegralRecordCount,
    method: "get",
    params,
  });
};
// 获取个人中心的学习记录
export function getLearningRecord() {
  return request({
    url: ouchnCustom + "/device/LearningRecord/statistics",
    // token: true,
    method: "get",
  });
}
